'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  cursor: pointer;\n  padding: 10px;\n  padding-left: ', ';\n  display: flex;\n  align-items: center;\n  border-style: none none solid none;\n  border-width: 1px;\n  border-color: ', ';\n  user-select: none;\n\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  width: 100%;\n  cursor: pointer;\n  padding: 10px;\n  padding-left: ', ';\n  display: flex;\n  align-items: center;\n  border-style: none none solid none;\n  border-width: 1px;\n  border-color: ', ';\n  user-select: none;\n\n  &:hover {\n    background: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-right: 10px;\n  font-size: ', 'px !important;\n  color: ', ';\n'], ['\n  margin-right: 10px;\n  font-size: ', 'px !important;\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  flex: 1;\n  font-size: ', 'px;\n  color: ', ';\n'], ['\n  flex: 1;\n  font-size: ', 'px;\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var inner = _ref.inner;
  return inner ? '40px' : '10px';
}, _colors.grey, _colors.grey);

var IconContainer = _styledComponents2.default.div(_templateObject2, function (_ref2) {
  var small = _ref2.small;
  return small ? 16 : 24;
}, function (_ref3) {
  var color = _ref3.color;
  return color ? _colors.blue : _colors.darkGrey;
});

var Name = _styledComponents2.default.div(_templateObject3, function (_ref4) {
  var small = _ref4.small;
  return small ? 10 : 12;
}, function (_ref5) {
  var color = _ref5.color;
  return color ? _colors.black : _colors.darkGrey;
});

var Folder = function Folder(_ref6) {
  var open = _ref6.open,
      small = _ref6.small,
      children = _ref6.children,
      inner = _ref6.inner,
      color = _ref6.color,
      onClick = _ref6.onClick;
  return _react2.default.createElement(Container, {
    inner: inner,
    onClick: onClick
  }, _react2.default.createElement(IconContainer, {
    small: small,
    color: color ? 1 : 0
  }, _react2.default.createElement(_Icon2.default, {
    icon: open ? 'folderopen' : 'folder1'
  })), _react2.default.createElement(Name, {
    color: color ? 1 : 0,
    small: small
  }, children));
};

Folder.propTypes = {
  open: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  inner: _propTypes2.default.bool,
  color: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
exports.default = Folder;